import { render, staticRenderFns } from "./QuotazioneClientePage.vue?vue&type=template&id=03e47562&scoped=true"
import script from "./QuotazioneClientePage.vue?vue&type=script&lang=js"
export * from "./QuotazioneClientePage.vue?vue&type=script&lang=js"
import style1 from "./QuotazioneClientePage.vue?vue&type=style&index=1&id=03e47562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e47562",
  null
  
)

export default component.exports